<template>
	<div
	class="pt-2 pb-2 clearfix"
	:class="containerClass"
	v-touch:tap="tapHandler"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>

		<template v-if="data">
			<p class="mt-0 mb-0"><strong>{{ data.formresponse_data.title }}</strong></p>
			<p class="mt-0 mb-0 small">
				<template v-if="data.formresponse_dateofresponse">
					{{ $datetime.getLocaleStringFromTimeStamp(data.formresponse_dateofresponse) }}
				</template>
				<template v-else>
					{{ $datetime.getLocaleStringFromTimeStamp(data.created) }}
				</template>
			</p>
		</template>

		<template v-else>

			<div class="float-left">
				<div class="skeleton midnight h20 w200 mb-3"></div>
				<div class="skeleton midnight h20 w50"></div>
			</div>
			<div class="float-right">
				<div class="skeleton midnight h20 w200"></div>
			</div>
		</template>


	</div>
</template>

<script>
export default {
	props: ['data', 'selectedItem'],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		tapHandler() {
			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		}
	},
	computed: {
		selected() {
			return this.selectedItem && this.selectedItem.formresponse_id == this.data.formresponse_id;
		},
		/*
		datetime(){
			if(this.data.created){
				var dateObj = this.$datetime.getDateObjectFromDateTimeField(this.data.created);
				if(dateObj){
					return this.$d(dateObj, 'datetime');
				}
				return null;
			}
			return null;
		},
		*/
		containerClass() {
			const classArr = [];
			if(this.selected) {
				classArr.push('active')
			}
			if (this.data && !this.read) {
				classArr.push('message--unread');
			}
			return classArr.join(' ');
		}
	}
};
</script>
